// Common search query: /web-design-pricing → /pricing (301).
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/web-design-pricing")({
  beforeLoad: () => {
    throw redirect({ to: "/pricing", statusCode: 301 });
  },
});
